import React from 'react';
import { Headphones, FileText, CheckSquare, Gift } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <Headphones className="text-amber-400" size={28} data-id="element-193" />,
    title: 'Audiolibro de Protocolo Nocturno',
    desc: '5 pistas diseñadas para guiar tu cerebro del estado de alerta al estado de archivo profundo.'
  }, {
    icon: <FileText className="text-amber-400" size={28} data-id="element-194" />,
    title: 'Guía PDF "Filtro de Acero"',
    desc: 'El paso a paso para limpiar tu mente de ruido antes de cerrar los ojos.'
  }, {
    icon: <CheckSquare className="text-amber-400" size={28} data-id="element-195" />,
    title: 'Plantilla de Vaciado de Pendientes',
    desc: 'El formato exacto para que tu cerebro "suelte" la carga y confíe en el papel.'
  }, {
    icon: <Gift className="text-amber-400" size={28} data-id="element-196" />,
    title: 'Bonus: Lista de Nutrientes de Acero',
    desc: 'Para eliminar la neblina mental matutina y despertar con energía renovada.'
  }];
  return <section className="py-16 md:py-24 bg-navy-800/20" data-id="element-197">
      <div className="container mx-auto px-4" data-id="element-198">
        <div className="max-w-5xl mx-auto" data-id="element-199">
          <h2 className="text-3xl md:text-4xl text-center mb-16" data-id="element-200">
            Lo que recibes hoy
          </h2>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-201">
            {items.map((item, index) => <div key={index} className="glass-panel p-6 flex gap-5 hover:bg-navy-800/80 transition-colors" data-id="element-202">
                <div className="shrink-0 w-14 h-14 rounded-xl bg-navy-900 border border-steel-400/10 flex items-center justify-center" data-id="element-203">
                  {item.icon}
                </div>
                <div data-id="element-204">
                  <h3 className="text-xl font-medium text-white mb-2" data-id="element-205">
                    {item.title}
                  </h3>
                  <p className="text-steel-400 leading-relaxed" data-id="element-206">{item.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}